module.exports = __webpack_public_path__ + "static/media/blockchainNews.c98786fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/blockchainNews.png
// module id = 1813
// module chunks = 146